'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaidTotals = exports.getVideoPlayViews = exports.getValueByActionName = exports.getAd = exports.PaidReportIcon = exports.getObjectTypeLabel = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _formatting = require('../../utils/formatting');

var _notAvailableComponent = require('../../reports/not-available-component');

var _notAvailableComponent2 = _interopRequireDefault(_notAvailableComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadingPaidDataSegmentStyle = {
  minHeight: 96
};

var cf = function cf(num) {
  return (0, _numeral2.default)(num).format('0,0');
};

var getObjectTypeLabel = exports.getObjectTypeLabel = function getObjectTypeLabel(objectType) {
  var types = {
    SHARE: 'Image',
    VIDEO: 'Video'
  };
  return _lodash2.default.get(types, objectType, 'Image');
};

var PaidReportIcon = exports.PaidReportIcon = function PaidReportIcon(_ref) {
  var objectType = _ref.ad.creative.object_type;

  var icons = {
    SHARE: 'image',
    VIDEO: 'youtube play'
  };
  var iconName = _lodash2.default.get(icons, objectType, 'circle');
  return _react2.default.createElement(_semanticUiReact.Popup, {
    content: getObjectTypeLabel(objectType), trigger: _react2.default.createElement(
      'span',
      null,
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
      _react2.default.createElement(_semanticUiReact.Icon, { name: iconName, color: 'pink' })
    )
  });
};

PaidReportIcon.propTypes = {
  ad: _propTypes2.default.object.isRequired
};

var getAd = exports.getAd = function getAd(_ref2) {
  var rawAd = _ref2.rawAd;
  return {
    ad: {
      name: _lodash2.default.get(rawAd, 'ad.name', 'NO NAME')
    },
    campaign: {
      name: _lodash2.default.get(rawAd, 'ad.campaign.name', 'NO NAME'),
      bidStrategy: _lodash2.default.get(rawAd, 'ad.campaign.bid_strategy', '-'),
      buyingType: _lodash2.default.get(rawAd, 'ad.campaign.buying_type', '-'),
      status: _lodash2.default.get(rawAd, 'ad.campaign.effective_status', '-'),
      budgetRemaining: _lodash2.default.get(rawAd, 'ad.campaign.budget_remaining', '-')
    },
    creative: {
      thumbnail: _lodash2.default.get(rawAd, 'ad.creative.thumbnail_url', '-'),
      objectType: _lodash2.default.get(rawAd, 'ad.creative.object_type', '-'),
      link: _lodash2.default.get(rawAd, 'ad.creative.instagram_permalink_url', '-')
    },
    insights: rawAd.insights ? {
      reach: _lodash2.default.get(rawAd, 'insights.reach', '-'),
      impressions: _lodash2.default.get(rawAd, 'insights.impressions', '-'),
      clicks: _lodash2.default.get(rawAd, 'insights.clicks', '-'),
      thruPlays: _lodash2.default.get(rawAd, 'insights.video_thruplay_watched_actions[0].value', '-'),
      sec3: _lodash2.default.get(rawAd, 'insights.video_play_curve_actions[0].value[3]', '-'),
      sec10: _lodash2.default.get(rawAd, 'insights.video_play_curve_actions[0].value[10]', '-'),
      avg: _lodash2.default.get(rawAd, 'insights.video_avg_time_watched_actions[0].value', '-')
    } : {
      reach: 0,
      impressions: 0,
      clicks: 0,
      thruPlays: 0,
      sec3: 0,
      sec10: 0,
      avg: 0
    }
  };
};

var NumberPopup = function NumberPopup(_ref3) {
  var num = _ref3.num,
      text = _ref3.text;
  return _react2.default.createElement(_semanticUiReact.Popup, { trigger: _react2.default.createElement(
      'span',
      null,
      (0, _formatting.paidReportFormat)(num)
    ), content: cf(num) + ' ' + text });
};

var getValueByActionName = exports.getValueByActionName = function getValueByActionName(ad) {
  var actionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'link_click';

  var action = _lodash2.default.find(_lodash2.default.get(ad, 'insights.actions', []), ['action_type', actionName]);
  var value = _lodash2.default.toNumber(_lodash2.default.get(action, 'value', 0));
  return value;
};

var getVideoPlayViews = exports.getVideoPlayViews = function getVideoPlayViews(ad) {
  var action = _lodash2.default.find(_lodash2.default.get(ad, 'insights.video_play_actions', []), ['action_type', 'video_view']);
  var value = _lodash2.default.toNumber(_lodash2.default.get(action, 'value', 0));
  return value;
};

var getPaidTotals = exports.getPaidTotals = function getPaidTotals(_ref4) {
  var data = _ref4.data;
  return {
    count: data.length,
    views: _lodash2.default.sumBy(data, function (ad) {
      return getVideoPlayViews(ad);
    }),
    shares: _lodash2.default.sumBy(data, function (ad) {
      return getValueByActionName(ad, 'post');
    }),
    comments: _lodash2.default.sumBy(data, function (ad) {
      return getValueByActionName(ad, 'comment');
    }),
    clicks: _lodash2.default.sumBy(data, function (ad) {
      return ad.insights ? Number(ad.insights.clicks) : 0;
    }),
    reactions: _lodash2.default.sumBy(data, function (ad) {
      return getValueByActionName(ad, 'post_reaction');
    }),
    impressions: _lodash2.default.sumBy(data, function (ad) {
      return ad.insights ? Number(ad.insights.impressions) : 0;
    }),
    reach: _lodash2.default.sumBy(data, function (ad) {
      return ad.insights ? Number(ad.insights.reach) : 0;
    }),
    thruPlays: _lodash2.default.sumBy(data, function (ad) {
      var thruplayActions = _lodash2.default.get(ad, 'insights.video_thruplay_watched_actions', null);
      if (thruplayActions) {
        return Number(ad.insights.video_thruplay_watched_actions[0].value);
      }
      return 0;
    })
  };
};

var whiteBackground = {
  background: 'white'
};

var PaidReportTable = function PaidReportTable(_ref5) {
  var isLoading = _ref5.isLoading,
      hasFailedToLoad = _ref5.hasFailedToLoad,
      filteredData = _ref5.data,
      title = _ref5.title;

  if (isLoading) {
    return _react2.default.createElement(
      _semanticUiReact.Segment,
      { style: loadingPaidDataSegmentStyle },
      _react2.default.createElement(_semanticUiReact.Loader, { content: 'Loading paid data...', active: true })
    );
  }

  if (hasFailedToLoad) {
    return _react2.default.createElement(_semanticUiReact.Message, {
      icon: 'frown',
      error: true,
      header: 'Failed to load paid data',
      content: 'Please try again later'
    });
  }

  if (_lodash2.default.isEmpty(filteredData)) {
    return null;
  }

  var totals = getPaidTotals({ data: filteredData });

  return _react2.default.createElement(
    _semanticUiReact.Card,
    { fluid: true },
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Card.Header,
        null,
        title
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Table,
        { celled: true, textAlign: 'center', style: { border: 0 } },
        _react2.default.createElement(
          _semanticUiReact.Table.Header,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { style: whiteBackground, width: 1 },
              'channel'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { style: whiteBackground, width: 1 },
              'image'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { style: whiteBackground, textAlign: 'left' },
              'influencer posts'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { style: whiteBackground, width: 1 },
              'type'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { style: whiteBackground, width: 1 },
              'status'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { style: whiteBackground, width: 1 },
              _react2.default.createElement(_semanticUiReact.Popup, { trigger: _react2.default.createElement(
                  'span',
                  null,
                  'imps'
                ), content: 'Impressions' })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { style: whiteBackground, width: 1 },
              'reach'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { style: whiteBackground, width: 1 },
              'clicks'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { style: whiteBackground, width: 1 },
              'views'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              {
                style: whiteBackground,
                width: 1
              },
              _react2.default.createElement(_semanticUiReact.Popup, {
                trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'thumbs up', color: 'grey' }),
                content: 'number of reactions'
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { style: whiteBackground, width: 1 },
              _react2.default.createElement(_semanticUiReact.Popup, {
                trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'comments', color: 'grey' }),
                content: 'number of comments'
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              {
                style: whiteBackground,
                width: 1
              },
              _react2.default.createElement(_semanticUiReact.Popup, {
                trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'share', color: 'grey' }),
                content: 'number of shares'
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          _lodash2.default.isArray(filteredData) && !_lodash2.default.isEmpty(filteredData) && _lodash2.default.map(filteredData, function (rawAd) {
            var _getAd = getAd({ rawAd: rawAd }),
                ad = _getAd.ad,
                campaign = _getAd.campaign,
                insights = _getAd.insights,
                creative = _getAd.creative;

            return _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'center' },
                _react2.default.createElement(PaidReportIcon, rawAd)
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'center' },
                _react2.default.createElement(
                  'a',
                  { href: creative.link, target: '_blank' },
                  _react2.default.createElement(_semanticUiReact.Image, { size: 'tiny', src: creative.thumbnail })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'left' },
                _react2.default.createElement(
                  'p',
                  null,
                  ad.name
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                getObjectTypeLabel(creative.objectType)
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                campaign.status
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                _react2.default.createElement(NumberPopup, {
                  num: insights.impressions,
                  text: 'impressions'
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                _react2.default.createElement(NumberPopup, { num: insights.reach, text: 'reach' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                _react2.default.createElement(NumberPopup, { num: insights.clicks, text: 'clicks' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                _react2.default.createElement(NumberPopup, { num: getVideoPlayViews(rawAd), text: 'video views' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                _react2.default.createElement(NumberPopup, { num: getValueByActionName(rawAd, 'post_reaction'), text: 'reactions' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                _react2.default.createElement(NumberPopup, { num: getValueByActionName(rawAd, 'comment'), text: 'comments' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                _react2.default.createElement(NumberPopup, { num: getValueByActionName(rawAd, 'post'), text: 'shares' })
              )
            );
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Footer,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { width: 1 }),
            _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { width: 1 }),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              'Totals Paid: (',
              totals.count,
              ' Ads)'
            ),
            _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { width: 1 }),
            _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { width: 1 }),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { width: 1 },
              _react2.default.createElement(NumberPopup, { num: totals.impressions, text: 'impressions' })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { width: 1 },
              _react2.default.createElement(NumberPopup, { num: totals.reach, text: 'reach' })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { width: 1 },
              _react2.default.createElement(NumberPopup, { num: totals.clicks, text: 'clicks' })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { width: 1 },
              _react2.default.createElement(NumberPopup, { num: totals.views, text: 'views' })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { width: 1 },
              _react2.default.createElement(NumberPopup, { num: totals.reactions, text: 'reactions' })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { width: 1 },
              _react2.default.createElement(NumberPopup, { num: totals.comments, text: 'comments' })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { width: 1 },
              _react2.default.createElement(NumberPopup, { num: totals.shares, text: 'shares' })
            )
          )
        )
      )
    )
  );
};

PaidReportTable.defaultProps = {
  title: 'Paid Amplification'
};

exports.default = PaidReportTable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/components/paid-report-table/index.js
// module id = 1059
// module chunks = 1